import { useQuery } from "@tanstack/react-query";


const getStrategyPeriod = async ({ startdate, month, loc }: { startdate: string, month: string, loc: string }) => {
    const response = await fetch(`/api/strategy/period?startdate=${startdate}&month=${month}&loc=${loc}`);
    return response.json();
};

const getStrategyDaily = async ({ tickers }: { tickers: string[] }) => {
    const queryParams = new URLSearchParams();
    tickers.forEach(ticker => queryParams.append('ticker', ticker));
    const response = await fetch(`/api/strategy/daily?${queryParams.toString()}`);
    return response.json();
};

const useStrategyPeriod = ({ startdate, month, loc }: { startdate: string, month: string, loc: string }) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['strategyPeriod', startdate, month, loc],
        queryFn: () => getStrategyPeriod({ startdate, month, loc }),
    });
    return { data, isLoading, error };
};

export const useStrategyDaily = ({ tickers, enabled = false }: { tickers: string[], enabled: boolean }) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['strategyDaily', tickers],
        queryFn: () => getStrategyDaily({ tickers }),
        enabled: enabled,
    });
    return { data, isLoading, error };
};

export default useStrategyPeriod;   